import gql from "graphql-tag";

/**
 * Graphql mutation used to initiate a shipping request
 */
const InitiateShippingRequest = gql`
  mutation {
    InitiateShippingRequest {
      id
      reference_number
      data
    }
  }
`;

export default InitiateShippingRequest;
